import React, { useState, useEffect } from 'react';
import TodoCard from "../components/todo/TodoCard";
import TodoInputGroup from "../components/todo/TodoInputGroup";

const TodoPage = ({ data, onSubmit }) => {
  const [todos, setTodos] = useState(data || []);

  useEffect(() => {
    setTodos(data || []);
  }, [data]);

  const handleCreate = async (insertData) => {
    const updatedTodos = [...todos, insertData];
    setTodos(updatedTodos);
    onSubmit(updatedTodos);
  };

  const handleDelete = (index) => {
    const updatedTodos = todos.filter((_, i) => i !== index);
    setTodos(updatedTodos);
    onSubmit(updatedTodos);
  };

  return (
    <main className="py-5 bg-secondary">
      <div className="container">
        <TodoInputGroup onCreate={handleCreate} />
        {todos.length === 0 && (
          <h2
            className="text-center"
            style={{ color: "var(--app-text, #ffffff)" }}
          >
            -- No items currently --
          </h2>
        )}
        <div className="d-flex flex-wrap">
          {todos.map((todo, index) => (
            <div key={index} className="p-1">
              <TodoCard
                goal={todo.goal}
                purpose={todo.purpose}
                todo={todo.todo}
                timing={todo.timing}
                onDelete={() => handleDelete(index)}
              />
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default TodoPage;
